import {Form} from "@rjsf/bootstrap-4";
import validator from '@rjsf/validator-ajv8';
import {Button, Card, Col, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import {AppButton} from "../../../Common/Component/Button/AppButton";
import {saveFormData} from "../FormDataService";
import Notify from "../../../Common/Notify/Notify";
import {getLocalDataForm, saveLocalDataForm} from "../FormDataLocalService";

export const CustomForm = ({
                               pageSchema,
                               onSaveAction,
                               onCancelAction,
                           }) => {

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [entityOnError, setEntityOnError] = useState(null);

    const onSubmit = (evt) => {
        let eventToSave = evt.formData;
        setLoading(true);

        if (pageSchema.formatObjectToSave) {
            eventToSave = pageSchema.formatObjectToSave(eventToSave)
        }


        saveFormData({formData: eventToSave, pageSchema}).then(x => {
            Notify.success('Entidade salva');
            setLoading(false);
            console.log('onSaveAction', onSaveAction)
            onSaveAction ? onSaveAction(x) : navigate(-1);

        }, err => {
            Notify.error('Falha ao salvar dados', err);
            setLoading(false);
            setEntityOnError(getLocalDataForm(pageSchema.entity));
        })
    }

    const onChange = (e, field) => {
        console.log('FORM DATA ', e.formData);
        if (field) {
            const data = e.formData;
            saveLocalDataForm(pageSchema.entity, data);
        }
    }

    const onError = (e) => {
        console.log('on errorrrrr', e)
    }

    console.log('pageSchema.uiSchema', pageSchema.uiSchema)

    return <Form
        disabled={isLoading}
        schema={pageSchema.formSchema}
        validator={validator}
        showErrorList={false}
        uiSchema={pageSchema.uiSchema}
        formData={entityOnError || pageSchema.originalFormData}
        onChange={onChange}
        onSubmit={onSubmit}
        onError={onError}
        customValidate={pageSchema.customValidate}
    >
        <Card.Footer style={{margin: '-1.25rem'}}>
            <Row>
                <Col>
                    {!(pageSchema.footer?.showCancelButton === false) &&
                        <Button size="sm" disabled={isLoading} variant="light" type="reset"
                                onClick={() => onCancelAction ? onCancelAction() : navigate(-1)}>Cancelar</Button>}
                </Col>
                <Col className="text-right">
                    <AppButton type="submit" isLoading={isLoading}>
                        <i className="fas fa-save"></i>
                        &nbsp;&nbsp;
                        Salvar
                    </AppButton>
                </Col>
            </Row>
        </Card.Footer>
    </Form>
}
